import ToastMessage from 'react-native-toast-message';
import { CustomToastProps } from './Toast.types';

export const Toast = {
  show: ({ type = 'success', title, text }: CustomToastProps) => {
    ToastMessage.show({
      type,
      text1: title,
      text2: text,
    });
  },
};
